import { createAsyncThunk } from "@reduxjs/toolkit";
import { AdminDashboardServices } from "@root/services/admin/dashboard";
import { prepareErrorResponse } from "@root/services/http/response";
import {
  DEACTIVATE_USER,
  GET_ACTIVITIES,
  GET_GRAPHS,
  GET_PENDING_TRANSACTIONS,
} from "@root/store/action-types/admin/admin";
import { getBaseUrl } from "@root/store/selectors/features";

const adminDashboardServices = new AdminDashboardServices();

export const getGraphesData: any = createAsyncThunk(
  GET_GRAPHS,
  async (requestPayload: any, thunkAPI: any) => {
    const { onSuccess, OnError, payload } = requestPayload;
    try {
      const baseUrl = getBaseUrl(thunkAPI.getState());
      const result = await adminDashboardServices.getGraphesData(
        baseUrl,
        payload
      );
      if (onSuccess) {
        onSuccess(result?.data?.data);
      }
      return thunkAPI.fulfillWithValue(result?.data?.data);
    } catch (error) {
      if (OnError) {
        OnError(error);
      }
      const customError = prepareErrorResponse(error);
      return thunkAPI.rejectWithValue(customError);
    }
  }
);

export const getActivites: any = createAsyncThunk(
  GET_ACTIVITIES,
  async (requestPayload: any, thunkAPI: any) => {
    const { onSuccess, onError, payload } = requestPayload;
    try {
      const baseUrl = getBaseUrl(thunkAPI.getState());
      const result = await adminDashboardServices.getActivities(
        baseUrl,
        payload
      );
      if (onSuccess) {
        onSuccess(result?.data?.data);
      }
      return thunkAPI.fulfillWithValue(result?.data?.data);
    } catch (error) {
      if (onError) {
        onError(error);
      }
      const customError = prepareErrorResponse(error);
      return thunkAPI.rejectWithValue(customError);
    }
  }
);
export const getPendingTransactions: any = createAsyncThunk(
  GET_PENDING_TRANSACTIONS,
  async (requestPayload: any, thunkAPI: any) => {
    const { onSuccess, OnError, payload } = requestPayload;
    try {
      const baseUrl = getBaseUrl(thunkAPI.getState());
      const result = await adminDashboardServices.getPendingTransactions(
        baseUrl,
        payload
      );
      if (onSuccess) {
        onSuccess(result?.data?.data);
      }
      return thunkAPI.fulfillWithValue(result?.data?.data);
    } catch (error) {
      if (OnError) {
        OnError(error);
      }
      const customError = prepareErrorResponse(error);
      return thunkAPI.rejectWithValue(customError);
    }
  }
);

export const deActivateUser: any = createAsyncThunk(
  DEACTIVATE_USER,
  async (requestPayload: any, thunkAPI: any) => {
    const { onSuccess, OnError, payload } = requestPayload;
    try {
      const baseUrl = getBaseUrl(thunkAPI.getState());
      const result = await adminDashboardServices.deActivateUser(
        baseUrl,
        payload
      );
      if (onSuccess) {
        onSuccess(result?.data?.data);
      }
      return thunkAPI.fulfillWithValue(result?.data?.data);
    } catch (error) {
      if (OnError) {
        OnError(error);
      }
      const customError = prepareErrorResponse(error);
      return thunkAPI.rejectWithValue(customError);
    }
  }
);
